import React from 'react';
import { useAdsData } from '@24i/player-utils-react';
import { IconName } from '../Icons';
import { Button, Title, StyledIcon } from './styled';
const ClickThrough = ({ className, playerInstance, styles }) => {
    const { isAdBreakActive, currentAd } = useAdsData(playerInstance);
    return isAdBreakActive && (currentAd === null || currentAd === void 0 ? void 0 : currentAd.clickLink) ? (React.createElement(Button, { style: styles.button, className: `ClickThrough ${className}`, "data-test": "ClickThrough", onClick: (event) => {
            event.stopPropagation();
        }, href: currentAd.clickLink, target: "blank" },
        React.createElement(StyledIcon, { style: styles.icon, className: "ClickThrough-Icon", name: IconName.info }),
        React.createElement(Title, { style: styles.title, className: "ClickThrough-Title" }, "Go to website"))) : null;
};
ClickThrough.defaultProps = {
    className: '',
    styles: {
        button: null,
        icon: null,
        title: null,
    },
};
export { ClickThrough };
//# sourceMappingURL=index.js.map